import { useBrandSpecialQualifyingStatus } from '@iheartjane/data-access/react-query';
import { FLAGS, useFlag } from '@iheartjane/feature-flags';
import {
  Button,
  CheckIcon,
  Flex,
  PartnerLogo,
  Typography,
} from '@iheartjane/reefer';

import { brandSpecialOrProductHasSegments } from '@jane/shared/util';

import { useKioskSpacing } from '../../../../hooks';
import { SpecialPdpCallout } from '../../SpecialPdpCallout/SpecialPdpCallout';
import type {
  JaneGoldPdpCalloutContainerProps,
  JaneGoldPdpCalloutProps,
} from '../JaneGoldCallout.types';

const JaneGoldPdpCallout = ({
  brandName,
  onClick,
  partnerLogo,
  showButton,
  showCheck,
  title,
}: JaneGoldPdpCalloutProps) => {
  const { isIpad } = useKioskSpacing();

  return (
    <Flex
      border="transparent-black-five"
      borderRadius="lg"
      width="100%"
      flexDirection="row"
      gap={16}
      p={16}
      alignItems="center"
      aria-label={`view ${title} special`}
      onClick={onClick}
    >
      <PartnerLogo
        variant="brand"
        name={brandName}
        image={partnerLogo}
        size="xs"
      />
      <Typography variant="body-bold">{title}</Typography>

      {showButton ? (
        <Button
          ml="auto"
          label="View bundle"
          variant="primary-inverse"
          size={isIpad ? 'small' : 'default'}
        />
      ) : showCheck ? (
        <CheckIcon ml="auto" />
      ) : null}
    </Flex>
  );
};

export const JaneGoldPdpCalloutContainer = ({
  brandSpecial,
  cartBrandDiscounts,
  cartUuid,
  onClick,
  storeId,
  userSignedIn,
}: JaneGoldPdpCalloutContainerProps) => {
  const isBundle = brandSpecial.special_type !== 'product';
  const { data: status } = useBrandSpecialQualifyingStatus(
    {
      cartUuid: cartUuid,
      specialId: brandSpecial.id,
      storeId: storeId,
    },
    { enabled: isBundle }
  );
  const segmentedDeal = brandSpecialOrProductHasSegments({ brandSpecial });
  const specialRedesign = useFlag(FLAGS.c3SpecialsRedesignMenu);

  const isApplied = cartBrandDiscounts?.some(
    (discount) => discount.brand_special_id === brandSpecial.id
  );
  const showButton =
    isBundle && status?.qualifying_status !== 'qualified' && !isApplied;
  const showCheck = isApplied && (userSignedIn || !segmentedDeal);

  return specialRedesign ? (
    <SpecialPdpCallout
      isGold
      brandName={brandSpecial.product_brand?.name ?? ''}
      partnerLogo={brandSpecial.product_brand?.logo_url ?? null}
      title={brandSpecial.title}
      showButton={showButton}
      showCheck={showCheck}
      onClick={() => onClick?.(brandSpecial)}
    />
  ) : (
    <JaneGoldPdpCallout
      brandName={brandSpecial.product_brand?.name ?? ''}
      partnerLogo={brandSpecial.product_brand?.logo_url ?? null}
      title={brandSpecial.title}
      showButton={showButton}
      showCheck={showCheck}
      onClick={() => onClick?.(brandSpecial)}
    />
  );
};
